import login from './login'
import telaInicial from './telaInicial'
import logout from './logout'
import errors from './errors'
import application from './application'

// const root = {
//   path: '/',
//   redirect: '/servidor',
// }

export default [...telaInicial, ...login, ...errors, ...logout, ...application]
